import { api } from "@/lib/api";

export async function uploadImage(file, folder) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post(`/uploads/image?folder=${folder}`, fd);
  return data.path;
}
